module.exports = __webpack_public_path__ + "static/media/logo-va-health-off.f35bb8a3.svg";